import addResizeListener from './resize';

const toggler = document.getElementById('nav-toggler');

toggler.addEventListener('click', () => {
  document.documentElement.classList.toggle('show-nav');
  addResizeListener();
});
